import React, { useEffect, useState } from 'react';
import { ultimateImages } from '../../data/ultimateData';

// Pure maroon hero — Karmakundali style
const C = {
  maroon: '#5B1818',
  maroonDark: '#3B0E0E',
  gold: '#C9A23A',
  goldLight: '#E2C170',
  goldSoft: '#F0DCA0',
  cream: '#F3EDE2',
  ivory: '#17171C',
  text: '#F3EDE2',
  textMuted: '#E8D8B0',
  border: 'rgba(201,162,58,0.40)',
};

const UltimateHero = () => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { setTimeout(() => setLoaded(true), 100); }, []);

  const scrollToForm = () => {
    if (typeof window.fbq === 'function') window.fbq('track', 'InitiateCheckout', { content_name: 'Hero CTA Click' });
    const el = document.getElementById('contact-form-section');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  return (
    <section
      className="relative min-h-screen overflow-hidden"
      data-testid="hero-section"
      style={{
        background: `linear-gradient(180deg, rgba(6,6,8,0.80) 0%, rgba(8,8,11,0.55) 45%, rgba(6,6,8,0.96) 100%), url('/img/d9315337.webp') center 28%/cover no-repeat, #0B0B0E`,
        color: C.text,
      }}
    >
      {/* Subtle texture only — no dimming overlays */}
      <div className="absolute inset-0 pointer-events-none opacity-10">
        <div className="absolute top-1/4 left-10 w-72 h-72 rounded-full blur-3xl" style={{ background: `radial-gradient(circle, rgba(255,110,20,0.35) 0%, transparent 70%)` }} />
        <div className="absolute bottom-1/4 right-10 w-80 h-80 rounded-full blur-3xl" style={{ background: `radial-gradient(circle, rgba(255,110,20,0.28) 0%, transparent 70%)` }} />
      </div>

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* LEFT - Content */}
          <div className="flex-1 text-center lg:text-left order-2 lg:order-1 relative z-10">
            {/* Trust badge */}
            <div className={`mb-5 transition-all duration-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <span
                className="inline-block px-5 py-2.5 rounded-full text-sm sm:text-base font-bold tracking-wider"
                style={{ background: 'rgba(45,122,79,0.18)', color: '#E2C170', border: '1px solid rgba(45,122,79,0.5)' }}
              >
                ❖ पहले जांच, संतुष्ट हों तो दक्षिणा — कोई जबरदस्ती नहीं
              </span>
            </div>

            {/* Main heading */}
            <div className={`mb-4 transition-all duration-700 delay-100 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-2" style={{ fontFamily: "'Tiro Devanagari Hindi', 'Rozha One', serif", color: C.cream }}>
                क्या आप परेशान हैं?
              </h1>
              <h2 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-black leading-tight" style={{ fontFamily: "'Tiro Devanagari Hindi', 'Rozha One', serif" }}>
                <span style={{ background: `linear-gradient(135deg, ${C.goldSoft} 0%, ${C.gold} 50%, ${C.goldSoft} 100%)`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.4))' }}>
                  माता मलिहा से बात करें!
                </span>
              </h2>
              <p className="text-lg mt-4" style={{ color: C.textMuted }}>
                सिर्फ अपना नाम बताइए, माता जी खुद सब बता देंगी — <span style={{ color: '#E2C170', fontWeight: 700 }}>बिना कुछ पूछे!</span>
              </p>
            </div>

            {/* Promise card 1 */}
            <div className={`mb-5 transition-all duration-700 delay-150 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <div className="p-4 rounded-xl" style={{ background: 'rgba(0,0,0,0.30)', border: `1px solid ${C.border}`, backdropFilter: 'blur(4px)' }}>
                <p className="text-base leading-relaxed" style={{ color: C.cream }}>
                  ❖ माता जी परची देखते ही <span style={{ color: C.goldLight, fontWeight: 700 }}>सीधे बता देती हैं</span> कि आपकी समस्या क्या है,
                  कौन दे रहा है, और समाधान क्या है। अगर सही लगे तभी आगे बढ़ें — <span style={{ color: '#E2C170', fontWeight: 700 }}>आपकी मर्जी!</span>
                </p>
              </div>
            </div>

            {/* What Mata Ji tells card */}
            <div className={`mb-5 transition-all duration-700 delay-200 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <div className="p-5 rounded-xl" style={{ background: 'rgba(0,0,0,0.30)', border: `1px solid ${C.border}`, backdropFilter: 'blur(4px)' }}>
                <p className="text-lg sm:text-xl font-bold mb-3" style={{ color: C.goldLight, fontFamily: "'Tiro Devanagari Hindi', serif" }}>
                  परची देखते ही माता जी बता देंगी:
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {[
                    { c: '◆', t: 'समस्या देने वाले का नाम' },
                    { c: '◆', t: 'आपके शहर/गाँव का नाम' },
                    { c: '✦', t: 'समस्या का असली कारण' },
                    { c: '✦', t: 'समाधान का रास्ता' },
                  ].map((it, i) => (
                    <div key={i} className="flex items-center gap-2 p-2.5 rounded-lg" style={{ background: 'rgba(201,162,58,0.10)', border: `1px solid ${C.border}` }}>
                      <span style={{ color: C.gold, fontSize: 18 }}>{it.c}</span>
                      <span className="font-bold text-sm" style={{ color: C.cream }}>{it.t}</span>
                    </div>
                  ))}
                </div>
                <p className="text-sm mt-3 text-center" style={{ color: C.textMuted }}>
                  ◈ अगर माता जी की बात सही लगे, तभी श्रद्धानुसार दक्षिणा दें
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className={`mb-4 transition-all duration-700 delay-300 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <button
                onClick={scrollToForm}
                data-testid="cta-consult-btn"
                className="group relative px-10 py-5 rounded-full transition-all transform hover:scale-105"
                style={{
                  background: 'linear-gradient(135deg, #1C0606 0%, #6E0F0F 100%)',
                  color: '#F5E7C8',
                  fontFamily: "'Tiro Devanagari Hindi', serif",
                  fontWeight: 800,
                  fontSize: '22px',
                  letterSpacing: '0.03em',
                  border: `1px solid ${C.gold}`,
                  boxShadow: '0 6px 30px rgba(201,162,58,0.45), inset 0 1px 0 rgba(255,255,255,0.3)',
                }}
              >
                ❖ माता जी से बात करें
              </button>
              <p className="text-sm mt-3" style={{ color: '#E2C170' }}>जांच के बाद संतुष्ट हों तो क्षमतानुसार दक्षिणा दें</p>
            </div>

            {/* Trust */}
            <div className={`transition-all duration-700 delay-300 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <p className="text-base sm:text-lg" style={{ color: C.cream }}>
                <span style={{ color: C.goldLight, fontWeight: 700 }}>50,000+</span> लोगों ने लिया फायदा &nbsp;|&nbsp;
                <span style={{ color: '#E2C170', fontWeight: 700 }}>97%</span> सफलता दर
              </p>
            </div>
          </div>

          {/* RIGHT - Mata Maliha Image (CLEAN, NO DIMMING OVERLAY) */}
          <div className={`flex-shrink-0 order-1 lg:order-2 -mb-24 lg:mb-0 transition-all duration-1000 ${loaded ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
            <div className="relative" data-testid="hero-portrait">
              <div className="absolute inset-0 blur-3xl" style={{ background: 'radial-gradient(circle, rgba(255,120,30,0.22) 0%, transparent 70%)' }} />
              <img
                src="/img/b2e8ed7d.webp"
                alt="माता मलिहा अघोर क्रिया करती हुईं"
                className="relative w-full sm:w-[440px] lg:w-[540px] h-auto mx-auto scale-110 sm:scale-100"
                style={{ mixBlendMode: 'screen', maskImage: 'radial-gradient(ellipse 88% 92% at 50% 42%, #000 40%, transparent 99%)', WebkitMaskImage: 'radial-gradient(ellipse 88% 92% at 50% 42%, #000 40%, transparent 99%)' }}
                loading="eager"
              />
            </div>
          </div>
        </div>

        {/* Stats Bar */}
        <div className={`mt-12 transition-all duration-700 delay-400 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-4xl mx-auto">
            {[
              { v: '25+', l: 'वर्षों का अनुभव' },
              { v: '50K+', l: 'संतुष्ट भक्त' },
              { v: '97%', l: 'सफलता दर' },
              { v: 'क्षमतानुसार', l: 'जांच दक्षिणा' },
            ].map((s, i) => (
              <div key={i} className="text-center p-4 rounded-xl" style={{ background: 'rgba(0,0,0,0.30)', border: `1px solid ${C.border}`, backdropFilter: 'blur(4px)' }}>
                <div className="text-2xl sm:text-3xl lg:text-4xl font-black" style={{ color: C.goldLight, fontFamily: "'Tiro Devanagari Hindi', serif" }}>{s.v}</div>
                <div className="text-xs sm:text-sm mt-1" style={{ color: C.textMuted }}>{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </section>
  );
};

export default UltimateHero;
